import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
export default function useProperties() {
  const {
    properties
  } = usePreviewData();
  return properties;
}